import { swaggerSplitApi as api } from "../swaggerApi"
import { CreateEvent, SuccessfullyCreateEvent } from "@app/data/createEvent/types";

const createEventApi = api.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    createEvent: builder.mutation<SuccessfullyCreateEvent, CreateEvent>({
      query: (body) => ({
        url: `/api/v1/events`,
        method: "POST",
        body,
      }),
    })
  })
})

export const { useCreateEventMutation } = createEventApi
